import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import examIcon from "@phosphor-icons/core/regular/exam.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const reportCardComments: Tool = {
    urlSlug: "report-card-comments",
    configName: "teacher-tool-report-card-comments",
    title: () => t`Report card comments`,
    description: () =>
        t`Generate personalized, constructive report card comments`,
    categories: [ToolCategories.Create, ToolCategories.Support],
    icon: examIcon,
    color: color.fadedGreen24,
    layout: Layout.Coeditor,
    reportingLabelId: "report-card-comments",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
    ],
    requestedInputs: [
        {
            description: () =>
                t`Optional. If not provided, we'll use a placeholder like [Student Name].`,
            inputKind: "TEXT_BOX",
            label: () => t`Student's first name`,
            variableName: "studentName",
            // TODO(reid): Figure out how name replacement should work
            // in Classroom/coediting v2.
            // shouldReplaceName: true,
        },
        {
            description: () => "",
            inputKind: "SINGLE_SELECT",
            label: () => t`Grade level`,
            required: true,
            selectOptions: [
                {
                    label: () => t`1st grade`,
                    value: "1st grade",
                },
                {
                    label: () => t`2nd grade`,
                    value: "2nd grade",
                },
                {
                    label: () => t`3rd grade`,
                    value: "3rd grade",
                },
                {
                    label: () => t`4th grade`,
                    value: "4th grade",
                },
                {
                    label: () => t`5th grade`,
                    value: "5th grade",
                },
                {
                    label: () => t`6th grade`,
                    value: "6th grade",
                },
                {
                    label: () => t`7th grade`,
                    value: "7th grade",
                },
                {
                    label: () => t`8th grade`,
                    value: "8th grade",
                },
                {
                    label: () => t`9th grade`,
                    value: "9th grade",
                },
                {
                    label: () => t`10th grade`,
                    value: "10th grade",
                },
                {
                    label: () => t`11th grade`,
                    value: "11th grade",
                },
                {
                    label: () => t`12th grade`,
                    value: "12th grade",
                },
                {
                    label: () => t`College`,
                    value: "College",
                },
            ],
            variableName: "gradeLevel",
        },
        {
            description: () =>
                t`e.g., assignments in on-time, good demeanor, on-task`,
            inputKind: "TEXT_BOX",
            label: () => t`Strengths and highlights`,
            required: true,
            variableName: "RCPros",
        },
        {
            description: () =>
                t`e.g., assignments often late, rude, easily distracted`,
            inputKind: "TEXT_BOX",
            label: () => t`Areas for improvement`,
            required: true,
            variableName: "RCCons",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
            />
        );
    },
};
